import axios from 'axios';

const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:5050/api/v1';
    }
    return `${window.location.origin}/api/v1`;
  }
  return 'http://localhost:5050/api/v1';
};

export const api = axios.create({
  baseURL: getBackendUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('scalesutra_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Response Interceptor for Automatic Silent Token Refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      originalRequest?.url?.includes('/auth/login') ||
      originalRequest?.url?.includes('/auth/refresh')
    ) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      if (typeof window !== 'undefined') {
        const refreshToken = localStorage.getItem('scalesutra_refresh_token');

        if (refreshToken) {
          try {
            const refreshUrl = `${getBackendUrl()}/auth/refresh`;
            const res = await axios.post(refreshUrl, {
              refresh_token: refreshToken,
            });

            if (res.data?.data?.access_token) {
              const newAccessToken = res.data.data.access_token;
              const newRefreshToken = res.data.data.refresh_token || res.data.data.refreshToken || refreshToken;

              localStorage.setItem('scalesutra_access_token', newAccessToken);
              localStorage.setItem('scalesutra_refresh_token', newRefreshToken);

              originalRequest.headers = originalRequest.headers || {};
              originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

              return api(originalRequest);
            }
          } catch (refreshError) {
            console.error('[Superadmin API Interceptor] Refresh failed:', refreshError);
            localStorage.removeItem('scalesutra_access_token');
            localStorage.removeItem('scalesutra_refresh_token');
            window.location.reload();
          }
        }
      }
    }

    return Promise.reject(error);
  }
);
